var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".check_svg__st11{fill:#e30613}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928.2 235.6c.6 1 1.3 1.9 1.9 2.9-.6-1-1.3-2-1.9-2.9zM873.4 270.7c.9 1.6 1.9 3.2 3.1 4.6-.8-1.3-1.6-2.5-2.5-3.8-.2-.3-.4-.6-.6-.8zM782.9 92.3c1.9 1.2 3.7 2.4 5.6 3.7-1.7-1.5-3.6-2.7-5.6-3.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M188.5 529l192.6 196.1 402.4-398.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M512 77.5c58.7 0 115.6 11.5 169.1 34.1 51.7 21.9 98.2 53.2 138.1 93.2 39.9 39.9 71.3 86.4 93.2 138.1 22.6 53.5 34.1 110.4 34.1 169.1S935 627.6 912.4 681.1c-21.9 51.7-53.2 98.2-93.2 138.1-39.9 39.9-86.4 71.3-138.1 93.2-53.5 22.6-110.4 34.1-169.1 34.1S396.4 935 342.9 912.4c-51.7-21.9-98.2-53.2-138.1-93.2-39.9-39.9-71.3-86.4-93.2-138.1C88.9 627.6 77.4 570.7 77.4 512s11.5-115.6 34.1-169.1c21.9-51.7 53.2-98.2 93.2-138.1 39.9-39.9 86.4-71.3 138.1-93.2C396.4 88.9 453.3 77.5 512 77.5m0-65C236.1 12.5 12.4 236.1 12.4 512s223.7 499.5 499.6 499.5 499.5-223.7 499.5-499.5S787.9 12.5 512 12.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default ForwardRef;